export default __webpack_public_path__ + "static/media/digital.06dc70be.wav";